import { Injectable } from '@angular/core';
import dayjs, { Dayjs, ManipulateType } from 'dayjs';
import calendar from 'dayjs/plugin/calendar';
import isoWeek from 'dayjs/plugin/isoWeek';
import utc from 'dayjs/plugin/utc';

/*import { LoggerService } from '@app/services/util-services/logger.service';*/
import { DateModel } from '@app/models/client/date.model';
import { ContainerItemOption } from '@app/models/server/layout.model';

// var calendar = require('dayjs/plugin/calendar')

dayjs.extend(utc);
dayjs.extend(calendar);
dayjs.extend(isoWeek);

@Injectable()
export class DayjsDateUtilLibService {
  constructor() {}

  isValidCheckInTimeOption(
    selectedDate: Date,
    checkinTimeOption: ContainerItemOption,
  ) {
    const today: dayjs.Dayjs = dayjs();
    const selected: dayjs.Dayjs = dayjs(
      `${dayjs(selectedDate).format('YYYY-MM-DD')} ${checkinTimeOption.value}`,
      'YYYY-MM-DD HH:mm',
    );
    /*LoggerService.log(
      'Inside isValidCheckInTimeOption today ',
      today,
      ' selected ',
      selected
    );*/
    if (today.isAfter(selected)) {
      return false;
    } else {
      return true;
    }
  }

  convertDateToDateModel(date: Date): DateModel {
    return this.createDateModel(dayjs(date));
  }

  convertDayJsDateToDateModel(dayjsDate: dayjs.Dayjs): DateModel {
    return this.createDateModel(dayjsDate);
  }

  convertStringDateToDateModel(date: string, format: string): DateModel {
    return this.createDateModel(
      dayjs(this.createDateFromFormattedDate(date, format)),
    );
  }

  private createDateModel(dayjsDate: dayjs.Dayjs): DateModel {
    const finalDateObj: DateModel = {
      date: dayjsDate.date(),
      dateObj: dayjs(dayjsDate, 'YYYY-MM-DD').toDate(),
      months: dayjsDate.month(),
      years: dayjsDate.year(),
      string: dayjsDate.format('YYYY-MM-DD'),
      timeString: dayjsDate.format('hh:mm a'),
      time: dayjsDate.valueOf(),
      unix: dayjsDate.unix(),
      displayMonth: this.getDisplayFormat(dayjsDate?.toDate(), 'MMM'),
      displayDay: this.getDisplayFormattedDate(dayjsDate.format('YYYY-MM-DD')),
    };

    // dayjsDate.
    /* LoggerService.log('finalDateObj ', finalDateObj);*/
    return finalDateObj;
  }

  public addToDate(amount: number, unit: ManipulateType, date: Date): Dayjs {
    return dayjs(date).add(amount, unit);
  }

  public subtractToDate(
    amount: number,
    unit: ManipulateType,
    date: Date,
  ): Dayjs {
    return dayjs(date).subtract(amount, unit);
  }

  // New functions starts
  getDisplayFormat(date: Date, format: string): string {
    return dayjs(date).format(format);
  }

  public createDateFromFormattedDate(
    date: Date | string,
    format: string,
  ): Date {
    return dayjs(date, format).toDate();
  }

  public createDayJsFromFormattedDate(
    date: Date | string,
    format: string,
  ): Dayjs {
    return dayjs(date, format);
  }

  // New functions starts
  getDisplayFormattedDate(date: Date | string): string {
    return dayjs(date).calendar(null, {
      // sameDay: '[Today]',
      // nextDay: '[Tomorrow]',
      // nextWeek: 'dddd',
      lastDay: '[Yesterday]',
      lastWeek: '[Last] dddd',
      // sameElse: 'DD/MM/YYYY',
      sameDay: 'ddd, [Today]',
      nextDay: 'ddd, [Tomorrow]',
      nextWeek: 'ddd, D MMM YYYY',
      sameElse: 'ddd, D MMM YYYY',
    });
  }

  public diff(date1: Date, date2: Date, unit: ManipulateType): number {
    return dayjs(date1).diff(dayjs(date2), unit);
  }

  withInDateRange(
    givenDate: Date,
    currentDate: Date,
    numberOfDays: number,
  ): boolean {
    const differnce: number = this.diff(currentDate, givenDate, 'days');

    if (numberOfDays >= differnce) {
      return true;
    } else {
      return false;
    }
  }

  public createDateAndTime(date: string, time: string): Date {
    const dateString: string = date + ' ' + time;
    return dayjs(dateString, 'YYYY-MM-DD HH:mm').toDate();
  }

  getShortstayMinimumDate(): dayjs.Dayjs {
    const today: dayjs.Dayjs = dayjs();
    let shortstayMinDate: dayjs.Dayjs = dayjs();
    shortstayMinDate = shortstayMinDate
      .set('hours', 23)
      .set('minutes', 1)
      .set('seconds', 0);
    /*LoggerService.log('shortstayMinDate ', shortstayMinDate?.toDate());
    LoggerService.log('today ', today?.toDate());*/
    /*LoggerService.log(
      'Inside isValidCheckInTimeOption today ',
      today,
      ' selected ',
      selected
    );*/
    if (today.isAfter(shortstayMinDate)) {
      // LoggerService.log('Inside getShortstayMinimumDate if');
      return this.addToDate(1, 'day', new Date());
    } else {
      // LoggerService.log('Inside getShortstayMinimumDate else');
      return dayjs();
    }
  }

  getExtendedstayMinimumDate(): dayjs.Dayjs {
    const today: dayjs.Dayjs = dayjs();
    let shortstayMinDate: dayjs.Dayjs = dayjs();
    shortstayMinDate = shortstayMinDate
      .set('hours', 21)
      .set('minutes', 1)
      .set('seconds', 0);
    /* LoggerService.log(
       'getExtendedstayMinimumDate shortstayMinDate ',
       shortstayMinDate?.toDate()
     );
     LoggerService.log('today ', today?.toDate());*/
    /*LoggerService.log(
      'Inside isValidCheckInTimeOption today ',
      today,
      ' selected ',
      selected
    );*/
    if (today.isAfter(shortstayMinDate)) {
      // LoggerService.log('Inside getShortstayMinimumDate if');
      return this.addToDate(1, 'day', new Date());
    } else {
      // LoggerService.log('Inside getShortstayMinimumDate else');
      return dayjs();
    }
  }

  isToday(date: string): boolean {
    return dayjs(date, 'YYYY-MM-DD').isSame(dayjs(), 'date');
  }

  isTomorrow(date: Date): boolean {
    return dayjs(date, 'YYYY-MM-DD').isSame(
      this.addToDate(1, 'day', new Date()),
      'date',
    );
  }

  isBefore(dayjsDate: dayjs.Dayjs): boolean {
    return dayjsDate.isBefore(dayjs(), 'date');
  }

  getDates(startDate: string, stopDate: string): string[] {
    const dateArray = [];
    let currentDate = dayjs(startDate, 'YYYY-MM-DD');
    const endDate = dayjs(stopDate, 'YYYY-MM-DD');
    while (currentDate <= endDate) {
      dateArray.push(dayjs(currentDate).format('YYYY-MM-DD'));
      currentDate = dayjs(currentDate).add(1, 'days');
    }
    return dateArray;
  }
}
